import { BaseComponent } from 'src/app/system-common/base/base.component';
import { BaseService } from 'src/app/system-common/services/base.service';
import { SettingService } from './../services/setting.service';
import { Component, OnInit, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { jwtDecode } from 'jwt-decode';
import { LoginService } from 'src/app/system-common/services/login.service';

@Component({
  selector: 'sym-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css'],
})
export class OtpComponent extends BaseComponent<BaseService> {
  /**
   * This is provided so that the current service is accesible to the component to reload .
   * e.g : QuotationService
   */
  @Input() service: BaseService;
  @Input() otpType: string;
  @Input() entityGuid: string;
  @Input() isOtpButtonReq: boolean;
  @Input() getOTP: boolean;
  @Input() triggerOTPGeneration: boolean;
  @Input() displayPopupOnly: boolean;
  @Input() otpRecipientAddress: { emailId: any; mobileNumber: any };
  @Input() otpExpiryTimeInput: number;
  @Input() otpErrorFailed: boolean;
  @Output() isValidOtp = new EventEmitter<boolean>();
  @Output() otpActionClicked = new EventEmitter<{ action: string; otp: any }>();
  currentOTP: any = '';
  timeLeft: string;
  remaining: number;
  otpResend: boolean;
  otpError: boolean;
  otpExpiryTime: number;
  recipientAddress = { emailId: null, mobileNumber: null };
  otpErrorMessage: string;
  public otpForm: UntypedFormGroup;
  constructor(
    public settingService: SettingService,
    protected formBuilder: UntypedFormBuilder,
    public loginService: LoginService
  ) {
    super(null);
    this.isOtpButtonReq = true;
    this.otpError = false;
    this.otpExpiryTime =
      SettingService.getApplicationPropertiesValue('OTP_EXPIRY_TIME') != undefined
        ? parseInt(SettingService.getApplicationPropertiesValue('OTP_EXPIRY_TIME'))
        : 300;
  }

  ngOnInit() {
    this.otpForm = this.formBuilder.group({
      otp: ['', [Validators.required, Validators.minLength(6)]],
    });
    this.getOTP = this.getOTP != undefined ? this.getOTP : false;
  }

  ngAfterViewInit() {
    if (this.getOTP == false)
      setTimeout(() => {
        $('#txtemailOTP').focus();
      }, 10);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['triggerOTPGeneration'] && changes['triggerOTPGeneration'].currentValue && !this.isOtpButtonReq) {
      if (this.triggerOTPGeneration) {
        this.onClickOtpbutton();
      }
    }
    if (changes['displayPopupOnly'] && changes['displayPopupOnly'].currentValue) {
      setTimeout(() => {
        $('#otpPopup').show();
        // this.timer();
      }, 10);
    }

    if (changes['otpExpiryTimeInput'] && changes['otpExpiryTimeInput'].currentValue) {
      if (this.otpExpiryTimeInput != undefined) this.otpExpiryTime = this.otpExpiryTimeInput;
      this.timer();
    }

    if (changes['otpRecipientAddress'] && changes['otpRecipientAddress'].currentValue) {
      this.recipientAddress = this.otpRecipientAddress;
    }

    if (changes['otpErrorFailed'] && changes['otpErrorFailed'].currentValue) {
      if (this.otpErrorFailed) {
        this.currentOTP = '';
        this.otpError = true;
      }
    }
  }

  return() {
    return;
  }
  onClickOtpbutton(): void {
    setTimeout(() => {
      $('#otpPopup').show();
    }, 10);
    this.generateOTP();
    this.currentOTP = '';
  }

  private timer(): void {
    this.remaining = this.otpExpiryTime;
    let extrunTimer = setInterval(() => {
      if (this.remaining >= 1) {
        this.otpResend = false;
        let minutes: any = Math.floor(this.remaining / 60);
        let seconds: any = this.remaining % 60;

        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        this.timeLeft = minutes + ':' + seconds;
        this.remaining -= 1;
      } else {
        this.otpResend = true;
        clearInterval(extrunTimer);
      }
    }, 1000);
  }

  public validateOTP(): void {
    if (this.service != undefined) {
      let otp = this.loginService.encryptPassword(this.currentOTP);
      let agentId = this.settingService.getSessionStorageValue('USER');
      let failedCount = 0;
      this.service.validateOTPOnLogin(this.otpType, this.entityGuid, otp).subscribe(
        (successResponse) => {
          let token = (successResponse as any)?.data?.token ?? null;
          const isSuccess =
            successResponse['success'] === true &&
            (this.otpType !== 'LOGIN' || (token && this.checkTokenValidity(token)));
          if (isSuccess) {
            this.closeModalSetup();
            this.isValidOtp.emit(true);
            this.settingService.setSessionStorageValue('FAILED_LOGIN_' + agentId, 0);
            console.log('Validate OTP successful.');
          } else {
            if (this.otpType === 'LOGIN') {
              const failedCountStr = this.settingService.getSessionStorageValue('FAILED_LOGIN_' + agentId);

              failedCount = parseInt(failedCountStr ?? '0', 10);
              failedCount = isNaN(failedCount) ? 1 : failedCount + 1;

              this.settingService.setSessionStorageValue('FAILED_LOGIN_' + agentId, failedCount.toString());
            }
            this.validateOTPFail(failedCount);
          }
        },
        (error) => {
          this.validateOTPFail(failedCount);
          console.log('Validate OTP failed.');
          console.log('Error:', error);
        }
      );
    } else {
      this.otpActionClicked.emit({ action: 'validateOTP', otp: this.currentOTP });
      // Commenting this call of method since the popup gets closed for an invalid otp
      // this.closeModalSetup();
    }
  }

  checkTokenValidity(token) {
    if (token) {
      let agentId = this.settingService.getSessionStorageValue('USER');
      let decoded: any;
      try {
        decoded = jwtDecode(token);
        if (decoded.applicationReferenceId == this.settingService.getSessionStorageValue('REFID' + agentId)) {
          return true;
        }
      } catch (err) {
        console.error('Failed to decode JWT:', err);
        return false;
      }
    } else {
      return false;
    }
  }

  private validateOTPFail(failedCount) {
    this.currentOTP = '';
    this.otpError = true;
    if (failedCount >= 3) {
      this.otpErrorMessage = 'Account is locked.';
    } else {
      this.otpErrorMessage = this.settingService.getLabelValue('invalidOtp');
    }
    this.isValidOtp.emit(false);
  }

  private generateOTP(): void {
    this.timer();
    this.otpError = false;
    let otpResponse: any;
    let agentId = this.settingService.getSessionStorageValue('USER');
    if (this.service != undefined) {
      this.service.generateOTP(this.otpType, this.entityGuid).subscribe(
        (successResponse) => {
          otpResponse = JSON.parse(JSON.stringify(successResponse));
          if (
            otpResponse != undefined &&
            otpResponse.data.recipientAddressList != undefined &&
            otpResponse.data.recipientAddressList.Status[0] == 'Success'
          ) {
            if (otpResponse.data.recipientAddressList.EMAIL != undefined)
              this.recipientAddress.emailId = otpResponse.data.recipientAddressList.EMAIL;
            if (otpResponse.data.recipientAddressList.SMS != undefined)
              this.recipientAddress.mobileNumber = otpResponse.data.recipientAddressList.SMS;
            console.log('Generate OTP successful.');
            this.settingService.setSessionStorageValue(
              'REFID' + agentId,
              otpResponse.data.recipientAddressList.SourceApplicationRefranceId[0]
            );
          } else {
            this.closeModalSetup();
            alert('Error while OTP generation, please try after ' + this.otpExpiryTime / 60 + ' minutes.');
            this.settingService.reloadCurrentRoute();
          }
        },
        (error) => {
          console.log('Generate OTP failed.');
          console.log('Error:', error);
        }
      );
    } else {
      this.otpActionClicked.emit({ action: 'resendOTP', otp: undefined });
    }
  }

  public getOTPClick(): void {
    this.getOTP = false;
    this.otpActionClicked.emit({ action: 'getOTP', otp: undefined });
    setTimeout(() => {
      $('#txtemailOTP').focus();
    }, 3500);
  }

  public resendOTP(): void {
    this.generateOTP();
  }

  public closeModal(): void {
    this.closeModalSetup();
    this.isValidOtp.emit(false);
  }

  private closeModalSetup() {
    this.remaining = 0;
    $('#otpPopup').hide();
  }
}
